import { AVATAR_GROUPS } from "../lib/avatars";

/**
 * The grid of icons a kid can be.
 *
 * Shared by the parent's "add a kid" form and the child's own picker, so the
 * two can never offer different sets. Selection is immediate and reversible —
 * there is no confirm step, because picking a different animal is not a
 * decision that needs one.
 */
export function AvatarPicker({
  value,
  onPick,
  disabled = false,
}: {
  value: string;
  onPick: (emoji: string) => void;
  disabled?: boolean;
}) {
  return (
    <div className="stack">
      {AVATAR_GROUPS.map((group) => (
        <div key={group.label} className="icon-group">
          <span className="icon-group__label">{group.label}</span>
          <div className="icon-grid">
            {group.emoji.map((emoji) => (
              <button
                key={emoji}
                type="button"
                className={`icon-choice ${
                  emoji === value ? "icon-choice--on" : ""
                }`}
                aria-pressed={emoji === value}
                aria-label={emoji}
                disabled={disabled}
                onClick={() => onPick(emoji)}
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
